import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Container,
    FormControlLabel,
    useMediaQuery,
    useTheme
} from "@mui/material";
import {useState} from "react";


function Streaming() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const [alternative, setAlternative] = useState(false);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent:'center',
                alignItems:'center',
                width: '100vw',
            }}
        >
            <header style={{flex: '0 0 auto'}}>
                <img
                    src={"/assets/header-desktop.jpg"}
                    alt="Header"
                    style={{width: '100%', display: 'block', height:'100%'}}
                />
            </header>

            <div  style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width:isMobile ? '90vw' : '60vw',
                aspectRatio: '16 / 9',
                flexDirection:'column',
                padding: '16px'
            }}>
                {/*<Typography variant={"h3"}>
                  The event will start soon
              </Typography>*/}

                {alternative ?
                    <iframe
                        src="https://vimeo.com/event/4898552/embed/552cb4292a"
                        frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                        style={{width: "100%", height: "100%"}} title="Alleanza">
                    </iframe>
                    :
                    <iframe
                        src="https://players.plesh.co/alleanza-gennaio-2025"
                        frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                        style={{width: "100%", height: "100%"}} title="Alleanza">
                    </iframe>
                }
            </div>
            <div  style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                width:isMobile ? '90vw' : '60vw',
                paddingBottom: '16px'
            }}>
                Problemi di riproduzione? <span onClick={() => setAlternative(!alternative)} style={{textDecoration:'underline', marginLeft:'5px', cursor:'pointer'}}> Streaming alternativo</span>
            </div>


            {loading &&
                <main style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '1 0 auto',
                    overflowY: 'auto',
                    textAlign: 'center',
                    margin: 'auto',
                    height: !isMobile ? '360px' : 'auto'
                }}>
                    <CircularProgress/>
                </main>
            }


            <footer style={{flex: '0 0 auto'}}>
                <img
                    src="/assets/footer.jpg"
                    alt="Footer"
                    style={{width: '100%', display: 'block'}}
                />
            </footer>

        </div>
    );
}

export default Streaming;